const INITIAL_FILTER_STATE = {
  parceiro: null,
  status: null,
  oracleRegistered: null,
};

const INITIAL_SORT_STATE = {
  parceiro: null,
  updatedAt: null,
};

export { INITIAL_FILTER_STATE, INITIAL_SORT_STATE };
